import { apiClient } from '@app/lib'
import { type SugarPaymentSetupConfirmResponse, type SugarPaymentSetupType } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

// mutationFn takes no arguments — { confirmed: true } is supplied server-side in confirmSugarPayment.
//
// onSuccess INVALIDATES rather than setQueryData: the confirm response is a strict subset of the GET
// payload (no accountName, no masked numbers), so writing it wholesale would blank the very fields the
// user just verified. Guarded on data.success so a forwarded rejection does not trigger a pointless
// refetch — a rejection arrives as HTTP 200 with success:false, so onSuccess fires either way.
export const useConfirmPaymentSetup = (paymentSetupType: SugarPaymentSetupType) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['confirmPaymentSetup', paymentSetupType],
    mutationFn: async () => {
      const { data } = await apiClient.post<SugarPaymentSetupConfirmResponse>(
        `/api/payment-setup/${paymentSetupType}`
      )

      return data
    },
    onSuccess: async (data) => {
      if (data.success) {
        await queryClient.invalidateQueries({
          queryKey: ['paymentSetup', paymentSetupType]
        })
      }

      return data
    }
  })
}
